/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Captcha_FlowsInputs */

const en_svchip_captcha_flows = /** @type {(inputs: Svchip_Captcha_FlowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CAPTCHA flows`)
};

const ar_svchip_captcha_flows = /** @type {(inputs: Svchip_Captcha_FlowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تدفقات CAPTCHA`)
};

const bn_svchip_captcha_flows = /** @type {(inputs: Svchip_Captcha_FlowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ক্যাপচা ফ্লো`)
};

const de_svchip_captcha_flows = /** @type {(inputs: Svchip_Captcha_FlowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CAPTCHA fließt`)
};

const es_svchip_captcha_flows = /** @type {(inputs: Svchip_Captcha_FlowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flujos CAPTCHA`)
};

const fr_svchip_captcha_flows = /** @type {(inputs: Svchip_Captcha_FlowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flux CAPTCHA`)
};

const pt_svchip_captcha_flows = /** @type {(inputs: Svchip_Captcha_FlowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fluxos CAPTCHA`)
};

const zh_svchip_captcha_flows = /** @type {(inputs: Svchip_Captcha_FlowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`验证码流程`)
};

const tr_svchip_captcha_flows = /** @type {(inputs: Svchip_Captcha_FlowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CAPTCHA akışları`)
};

const ru_svchip_captcha_flows = /** @type {(inputs: Svchip_Captcha_FlowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`потоки CAPTCHA`)
};

const pl_svchip_captcha_flows = /** @type {(inputs: Svchip_Captcha_FlowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przepływy CAPTCHA`)
};

/**
* | output |
* | --- |
* | "CAPTCHA flows" |
*
* @param {Svchip_Captcha_FlowsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_captcha_flows = /** @type {((inputs?: Svchip_Captcha_FlowsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Captcha_FlowsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_captcha_flows(inputs)
	if (locale === "bn") return bn_svchip_captcha_flows(inputs)
	if (locale === "de") return de_svchip_captcha_flows(inputs)
	if (locale === "es") return es_svchip_captcha_flows(inputs)
	if (locale === "fr") return fr_svchip_captcha_flows(inputs)
	if (locale === "pt") return pt_svchip_captcha_flows(inputs)
	if (locale === "zh") return zh_svchip_captcha_flows(inputs)
	if (locale === "tr") return tr_svchip_captcha_flows(inputs)
	if (locale === "ru") return ru_svchip_captcha_flows(inputs)
	if (locale === "pl") return pl_svchip_captcha_flows(inputs)
	return en_svchip_captcha_flows(inputs)
});